<template>
    <div class="center">
        <div class="items" v-for="item in contentList" :key="item.uuid">
            <img :src="item.value" alt="" srcset="">
            <p class="title">{{ item.name }}</p>
            <p class="text">{{ item.remarks }}</p>
        </div>
    </div>
</template>
<script>
import { getIndexDictionaryData } from "@/utils/interface";
export default {
    data() {
        return {
            contentList: []
        }
    },
    created() {
        this.getInfo()
    },
    methods: {
        getInfo() {
            getIndexDictionaryData({
                groupCode: "PTJS",
            })
                .then((res) => {
                    this.contentList = res;
                    // for (let i = 0; i < res.length; i++) {
                    //     this.contentImageList[i].title = res[i].name;
                    // }

                    // this.contentList[this.contentTbas].name = res[this.contentTbas].name;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
}

</script>
<style scoped lang="less">
.center {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 100px;
}

.items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 275px;
    img {
        width: 165px;
        height: 148px;
    }

    .title {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin:16px 0;
    }

    .text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6E6E6E;
        line-height: 28px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/homeIndex/advantage.vue